module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-disdik",
  //subdomain: "disdik"
};
